import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';

export const removeReadOnlyFields = <T extends object>(
  obj: T,
  fields: string[]
): T => {
  const objToReturn = { ...obj };
  fields.forEach((field) => {
    delete objToReturn[field];
  });
  return objToReturn;
};

export const normalize = <T>(obj: any): T => {
  return camelcaseKeys(obj, { deep: true }) as T;
};

export const denormalize = <T>(obj: any): T => {
  return decamelizeKeys(obj, { deep: true }) as T;
};

export const denormalizeToFormData = (obj: any) => {
  const formData = new FormData();
  const denormalizedObj = decamelizeKeys(obj, { deep: true });

  const appendData = (key: string, value: any) => {
    if (value instanceof Date) {
      formData.append(key, value.toISOString());
    } else if (Array.isArray(value)) {
      value.forEach((item, index) => {
        if (typeof item === 'object' && item !== null) {
          Object.entries(item).forEach(([nestedKey, nestedValue]) => {
            appendData(`${key}[${index}][${nestedKey}]`, nestedValue);
          });
        } else {
          appendData(`${key}[]`, item);
        }
      });
    } else if (typeof value === 'object' && value !== null) {
      Object.entries(value).forEach(([nestedKey, nestedValue]) => {
        appendData(`${key}[${nestedKey}]`, nestedValue);
      });
    } else if (value !== null && value !== undefined) {
      formData.append(key, value.toString());
    }
  };

  Object.entries(denormalizedObj).forEach(([key, value]) => {
    appendData(key, value);
  });

  return formData;
};
